import { FileSelector } from "components/base/Form";
import ImagesGridView from "components/base/ImagesGridView";
import { InlineSpinner } from "components/base/Spinner";
import useFileUploader from "hooks/useFileUploader";

const ImagesView = ({
  images,
  onChange,
  service = "AWS",
  isSaving = false,
}) => {
  const { isUploading, handleFileUpload } = useFileUploader(
    handleUploadedFiles,
    service,
  );

  const imageUrls = images.map((i) => i.url);

  function handleUploadedFiles(urls) {
    onChange([...imageUrls, ...urls]);
  }

  function imageDeleteHandler(index) {
    if (window.confirm("Are you sure you want to delete this image?")) {
      const newImages = [...imageUrls];
      newImages.splice(index, 1);
      onChange(newImages);
    }
  }

  return (
    <div className="card space-y-2">
      <h5>Images</h5>

      {images.length > 0 && (
        <ImagesGridView images={images} deleteHandler={imageDeleteHandler} />
      )}

      <div className="flex items-center space-x-3">
        <FileSelector
          title="+ Upload Images"
          uploading={isUploading || isSaving}
          onChange={(e) => {
            const files = [...e.target.files];
            handleFileUpload(files);
            e.target.value = null;
          }}
        />

        {isSaving && <InlineSpinner text={null} size={18} />}
      </div>
    </div>
  );
};

export default ImagesView;
